import { Component, OnInit, Renderer } from '@angular/core';
import { DataService } from '../../services/data.service';
import { VideoDetailsComponent } from './videoDetails';
import { ActivatedRoute } from '@angular/router';
import { Observable, Observer } from 'rxjs/Rx';
import { saveAs } from 'file-saver';
import * as moment from 'moment/moment';

@Component({
    selector: 'experience-report',
    template: require('./experienceReport.html'),
    styles: [require('./experienceReport.css')]
})
export class ExperienceReportComponent implements OnInit {
    public activeDashboard: any;
    public activeRoute: string;
    public participantData: any;
    public participantPageSize: number;
    public participantTableColumns: Array<any>;
    public components: any;
    public defaultDateFormat: string = "DD/MM/YYYY";
    public pageNumber: number = 1;
    public totalParticipantCount: number;
    public downloadKey: string;
    public checked: Boolean = false;
    public eventTitle: string;
    public searchText: string = '';
    public searchOn: Array<string>;
    public fixedKeys: Array<string>;
    public questions: Array<string>;
    public searchOnQuestions: Array<string>;
    public defaultSortColumn: string;
    public defaultSortOrder: string;
    public calledFrom: string = 'init';
    public downloadSelectedBtnText: string = 'Download Selected';
    public downloadSelectedBtnDisabled: boolean = false;

    public downloadPdfButton: boolean = false;
    public downloadVideosButton: boolean = false;
    public downloadPdfButtonText: string = '';
    public downloadVideosButtonText: string = '';
    public downloadPdfReport: boolean;
    public myDateRangePickerOptions: any = {};
    public fromDate: any;
    public toDate: any;
    public filterOnCompany: boolean = false;
    public selectedCompany: number = 0;
    public filters:any;
    public filterQuestions:Array<string> = [];
    public filterList:any;
    private filterValue: any = {};
    public attemptNumberText: string = 'attempt';
    public progress: any;

    constructor(public dataService: DataService, public activatedRoute: ActivatedRoute, public renderer: Renderer) { }

    ngOnInit() {       
        this.activeRoute = this.activatedRoute.snapshot.params['id'];
        if (this.activatedRoute.snapshot.params["search"]) {
            this.searchText = this.activatedRoute.snapshot.params["search"];
        }
        else if (this.activatedRoute.snapshot.queryParams["search"]) {
            this.searchText = this.activatedRoute.snapshot.queryParams["search"];
        }
        else {
            this.searchText = '';
        }

        let dashboard: any;
        var self = this;

        for (let i = 0; i < this.dataService.dashboards.length; i++) {
            if (this.dataService.dashboards[i].id === this.activeRoute) {
                dashboard = this.dataService.dashboards[i];
                this.activeDashboard = dashboard;
            }
        }

        this.components = this.activeDashboard.components[0];
        if (this.components.attemptNumberText) {
            this.attemptNumberText = this.components.attemptNumberText;
        }
        this.dataService.participantPageSize = this.components.pageSize;
        this.participantPageSize = this.components.pageSize;
        this.eventTitle = this.components.eventName;
        this.searchOn = this.components.searchOn;
        this.fixedKeys = this.components.fixedKeys;
        this.questions = this.components.questions;
        this.filterOnCompany = this.activeDashboard.enableCompanyFilter;
        this.defaultSortColumn = this.components.defaultSortColumn;
        this.defaultSortOrder = this.components.defaultSortOrder;
        this.searchOnQuestions = this.components.searchOnQuestions;
        this.filters = this.components.filters;
        this.progress = this.components.progressColumn;
        if(this.filters) {
            this.filters.forEach(ele => {
                if(ele.question) {
                    this.filterQuestions.push(ele.question);
                    this.filterValue[ele.question] = "0"; 
                }            
            })
        }        

        this.downloadPdfButton = this.components.downloadPdfButton;
        if (this.downloadPdfButton)
            this.downloadPdfButtonText = this.components.downloadPdfButtonText;

        this.downloadVideosButton = this.components.downloadVideosButton;
        if (this.downloadVideosButton)
            this.downloadVideosButtonText = this.components.downloadVideosButtonText;

        this.downloadPdfReport = (this.components.downloadPdfReport === false) ? false : true;
        this.calledFrom = 'load'
        this.fetchParticipantDetails();
        this.setDateRangePickerOptions(); 
    }

    fetchParticipantDetails() {
        var self = this;
        if (this.calledFrom === 'more') {
            this.pageNumber++;
        }
        
        this.dataService.getParticipantData(this.activeRoute, this.pageNumber, this.eventTitle, this.searchOn,
            this.fixedKeys, this.questions, this.defaultSortColumn, this.defaultSortOrder, this.searchText, this.searchOnQuestions,this.fromDate,this.toDate, this.filterOnCompany, this.selectedCompany, this.filterQuestions, this.filterValue).subscribe((data) => {                
                if (data && data.success && data.result) {
                    data.result.map((val, i) => {
                        if (val.actionname) {
                            val.actionname = val.actionname.split('|');                          
                        }
                        if (val.languagekey !=null) {
                            val.languagekey = val.languagekey.split('|');                           
                        }
                        if(val.languagekey!=null || val.actionname)
                        val.download = val.download.split('|');

                        if (val.trynumber !=null && val.trynumber.length > 0) {
                            val.trynumber = val.trynumber.split('|');                           
                        }

                                                
                        if(this.progress && this.progress.progressDates) {
                            val[this.progress.columnName] = ''
                            var startDate = '';
                            var endDate = '';                            
                            
                            if(this.progress.progressDates[0].key == "startdate") {
                                startDate = val[this.progress.progressDates[0].questioName];
                            }

                            if(this.progress.progressDates[1].key == "enddate") {
                                endDate = val[this.progress.progressDates[1].questioName];
                            }

                            if(endDate != '') {
                                val[this.progress.columnName] = this.progress.progressStatus[0];
                            }
                            else if (startDate != '') {
                                val[this.progress.columnName] = this.progress.progressStatus[1];
                            } else {
                                val[this.progress.columnName] = this.progress.progressStatus[2];;
                            }
                        }
                    })
                }
                if (self.calledFrom === 'more') {
                    for (var i = 0; i < data.result.length; i++) {
                        self.participantData.result.push(data.result[i]);
                    }
                }
                else {
                    self.participantData = data;
                }               
                self.totalParticipantCount = self.participantData.total;               
                self.formatDatesInData(data);
                if (self.calledFrom === 'load') {
                    this.filterList = self.participantData.filterList;                
                }      
            });
    }

    formatDatesInData(data) {
        if (!data.success) {
            console.log('Could not get data:', data.message);
            return;
        }
        let participantData = data.result;
        let columnOrder = this.components.order;

        for (var i = 0; i < participantData.length; i++) {
            for (var j = 0; j < columnOrder.length; j++) {
                if (columnOrder[j]["isDate"]) {
                    if (new Date(participantData[i][columnOrder[j]["key"]]).toString() != 'Invalid Date') {
                        if (columnOrder[j]["format"]) {
                            participantData[i][columnOrder[j]["key"]] = moment(participantData[i][columnOrder[j]["key"]]).format(columnOrder[j]["format"]);
                        }
                        else {
                            participantData[i][columnOrder[j]["key"]] = moment(participantData[i][columnOrder[j]["key"]]).format(this.defaultDateFormat);
                        }
                    }
                }
                else if (columnOrder[j]["isDownload"]) {
                    this.downloadKey = columnOrder[j]["key"];
                }
            }
        }
    }

    moreClicked(event) {
        this.calledFrom = 'more';
        this.fetchParticipantDetails();
    }

    checkAll(event) {
        this.checked = !this.checked;
    }

    sortParticipants(event, k) {
        if (!event.target.classList.contains("participants-sort-curr")) {
            for (var i = 0; i < document.getElementsByClassName("participants-sort").length; i++) {
                this.renderer.setElementClass(document.getElementsByClassName("participants-sort")[i], "participants-sort-curr", false);
                this.renderer.setElementClass(document.getElementsByClassName("participants-sort")[i], "participants-sort-asc", true);
                this.renderer.setElementClass(document.getElementsByClassName("participants-sort")[i], "participants-sort-desc", false);
            }

            this.renderer.setElementClass(event.target, "participants-sort-asc", true);
            this.renderer.setElementClass(event.target, "participants-sort-curr", true);

            this.defaultSortOrder = 'ASC';
            this.defaultSortColumn = k;
        }
        else {
            if (event.target.classList.contains("participants-sort-curr")) {
                if (event.target.classList.contains("participants-sort-asc")) {
                    this.renderer.setElementClass(event.target, "participants-sort-asc", false);
                    this.renderer.setElementClass(event.target, "participants-sort-desc", true);
                    this.defaultSortOrder = 'DESC';
                }
                else {
                    this.renderer.setElementClass(event.target, "participants-sort-asc", true);
                    this.renderer.setElementClass(event.target, "participants-sort-desc", false);
                    this.defaultSortOrder = 'ASC';
                }
            }
        }

        this.pageNumber = 1;
        this.calledFrom = 'sort';
        this.fetchParticipantDetails();
    }

    downloadReport(id, email, actionName?: null, tryNumber?: null) {
        let arr = new Array<string>();
        arr.push(id);
        this.dataService.downloadReport(this.activeRoute, this.eventTitle, arr).subscribe(data => {
            if (actionName != null) {
                if (tryNumber != null) {
                    saveAs(data, email+ "_"+actionName + "_" + this.attemptNumberText + "_" + tryNumber + ".pdf");
                } else {
                    saveAs(data, email+ "_"+actionName + ".pdf");
                }
            } else {
                saveAs(data, email + ".pdf");
            }
        });
    }

    OpenDashboardReport(reportId, email) {
        this.dataService.getServerDetails(this.eventTitle).subscribe(data => {
            var serverConfig = data._body.split('&');
            var serverUrl = serverConfig[0];
            var userName = serverConfig[1];
            var password = serverConfig[2];
            window.open(serverUrl + '/Wizer/DataDashboard/OpenDashboardReport?reportId=' + reportId + '&asEmail=' + email + '&email=' + userName + '&password=' + password + '&eventTitle=' + this.eventTitle, '_blank');
        });
    }

    parseJwt(token) {
        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace('-', '+').replace('_', '/');
        return JSON.parse(window.atob(base64));
    };

    onCompanyChange(companyId) {        
        this.selectedCompany = companyId;
        this.pageNumber = 1;
        this.calledFrom = 'company';
        this.fetchParticipantDetails();    
    }

    onFilterChange(event, key){
        this.calledFrom = 'filter'; 
        this.filterValue[key] = event;    
        this.fetchParticipantDetails();
    }

    downloadSelected(event) {
        let arr = new Array<string>();
        var checkedParticipantRows = document.getElementsByClassName("participants-row-check")
        for (var i = 0; i < checkedParticipantRows.length; i++) {
            if ((<HTMLInputElement>checkedParticipantRows[i]).checked && ((<HTMLInputElement>checkedParticipantRows[i]).className.indexOf('hidden-checkbox') === -1)) {
            //arr.push(parseInt((<HTMLInputElement>checkedParticipantRows[i]).value));
          
            for (var j = 0; j < (<HTMLInputElement>checkedParticipantRows[i]).value.split(',').length; j++) {
            arr.push((<HTMLInputElement>checkedParticipantRows[i]).value.split(',')[j]);
            }
                
        }
    }

        if (arr.length == 1) {
            this.downloadReport(arr[0],"Report");
            return;
        }

        if (arr.length > 1) {
            let pdfBtnText = this.downloadPdfButtonText;
            this.downloadPdfButtonText = 'Please Wait...';
            this.downloadSelectedBtnDisabled = true;
            this.dataService.downloadReport(this.activeRoute, this.eventTitle, arr).subscribe(data => {
                saveAs(data, "Reports.zip");

                this.downloadPdfButtonText = pdfBtnText;
                this.downloadSelectedBtnDisabled = false;
            });
        }
    }

    downloadSelectedVideos(event) {
        let videoObj = [];
        let key;
        let participantData = this.participantData.result;
        let componentOrder = this.components.order;
        let checkedParticipantRows = document.getElementsByClassName("participants-row-check")
        for (let i = 0; i < checkedParticipantRows.length; i++) {
            if ((<HTMLInputElement>checkedParticipantRows[i]).checked) {
                let videoElements = (checkedParticipantRows[i].parentElement.parentElement.getElementsByTagName('videodetails'));
                if (videoElements.length > 0) {
                    let result = participantData[i];
                    if (result) {
                        for (let j = 0; j < componentOrder.length; j++) {
                            if (componentOrder[j].isVideo) {
                                key = componentOrder[j].key;
                            }
                            if (key && participantData[i][key] !== "") {
                                let jObj = JSON.parse(participantData[i][key]);
                                if (jObj) {
                                    videoObj.push({
                                        "archiveId": jObj.name,
                                        "time": jObj.time.replace(/\.[0-9]{3}Z/, 'Z'),
                                        "participant": result.name.replace(/ /g, '-'),
                                        "question": componentOrder[j].title.trim().replace(/ /g, '-')
                                    });
                                }
                            }
                            key = null;
                        }
                    }

                }
            }
        }

        if (videoObj.length > 0) {
            let videoBtnText = this.downloadVideosButtonText;
            this.downloadVideosButtonText = 'Please Wait...';
            this.downloadSelectedBtnDisabled = true;
            let videoConfig = { "videos": videoObj };
            this.dataService.downloadVideo(this.activeRoute, this.eventTitle, JSON.stringify(videoConfig)).subscribe(data => {
                if (videoObj.length > 1) //download as zip
                    saveAs(data, "VideoReports.zip");
                else {
                    let jsonData = JSON.parse(JSON.stringify(videoObj));
                    saveAs(data, (jsonData[0].participant + '__' + jsonData[0].question) + '__' + jsonData[0].time + ".mp4");
                }
                this.downloadVideosButtonText = videoBtnText;
                this.downloadSelectedBtnDisabled = false;
            });
        }
    }

    searchParticipants(event) {
        this.pageNumber = 1;
        this.calledFrom = 'search';
        this.fetchParticipantDetails();
    }

    showVideoDetails(email, question) {
        console.log('I would like to show video information for', email, question);
    }


    showLanguagekeywiseAction(h: any, p: any, i: number) {
        if ((h.isDownload || h.isView ) && p.download[i] != '0') {
            if (h.acceptableLanguageKey) {
                if ((h.acceptableLanguageKey.indexOf(p.languagekey[i]) !== -1)) {
                    if (h.isDownload) {
                        p.isView = false;
                    } else if (h.isView) {
                        p.isView = true;
                    }
                    return true;
                } else {
                    return false;
                }
            } else {
                p.isView = false;
                return true;
            }
        }
        return false;
    }

    showActionName(h: any, p: any, i: number) {
        if ((h.isDownload || h.isView) && p.download[i] != '0') {
            if (h.acceptableActions) {
                if ((h.acceptableActions.indexOf(p.actionname[i]) !== -1)) {
                    if (h.isDownload) {
                        p.isView = false;
                    } else if (h.isView) {
                        p.isView = true;
                    }
                    return true;
                } else {
                    return false;
                }
            } else {
                p.isView = false;
                return true;
            }
        }
        return false;
    }

    // Sets the date range picker
    setDateRangePickerOptions() {
        this.myDateRangePickerOptions = {
            clearBtnTxt: 'Clear',
            beginDateBtnTxt: 'Start Date',
            endDateBtnTxt: 'End Date',
            acceptBtnTxt: 'Apply',
            dateFormat: 'mm/dd/yyyy',
            firstDayOfWeek: 'mo',
            sunHighlight: true,
            height: '34px',
            width: '260px',
            inline: false,
            selectionTxtFontSize: '15px',
            alignSelectorRight: false,
            indicateInvalidDateRange: true,
            showDateRangeFormatPlaceholder: false,
            showClearBtn: false,
            showClearDateRangeBtn: true,
            disableSince: {
                year: moment(new Date()).add(1, 'day').format('YYYY'),
                month: moment(new Date()).add(1, 'day').format('MM'),
                day: moment(new Date()).add(1, 'day').format('DD')
            }
        };
    }
   // Gets called on change of the time duration
   onDateRangeChanged(event: any) {
    this.pageNumber = 1;
    this.calledFrom = 'dateFilter';
       if(event.beginDate.month && event.endDate.month){
        this.fromDate = new Date(event.beginDate.year, event.beginDate.month - 1, event.beginDate.day);
        this.toDate = new Date(event.endDate.year, event.endDate.month - 1, event.endDate.day);
       }
       else{
        this.fromDate ='';
        this.toDate ='';
       }
       this.fetchParticipantDetails();
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/viewsmodule/experienceReport/experienceReport.ts